module.exports = "/packs/benefit-thumbnail-sp-3898625e2f1e46f0bc0b1451533ab49f.png";